import LocalizedStrings from 'react-localization';

export const strings = new LocalizedStrings({
  en: {
    errorMessage: 'There has been an error!',
    pleaseGiveFeedback: 'Please give feedback on activity when error occurred',
    problemLoadingPage: 'Sorry, there was a problem loading the page.',
  }
});